export default __webpack_public_path__ + "static/media/new-pitch-tow-cricket.9fb7b83e.png";